export default {
  dictionary: {
    init: {
      label: 'Zainicjowanie salda',
      value: 1,
      color: 'gray',
    },
    clientActivation: {
      label: 'Aktywacja klienta',
      value: 2,
      color: 'success',
    },
    ocr: {
      label: 'OCR',
      value: 3,
      color: 'orange',
    },
    manualRecharge: {
      label: 'Ręczne doładowanie',
      value: 4,
      color: 'darkgreen',
    },
    documentsAdd: {
      label: 'Dodanie dokumentu',
      value: 5,
      color: 'brown',
    },
    order: {
      label: 'Zakup',
      value: 6,
      color: 'success',
    },
    clientDeactivation: {
      label: 'Dezaktywacja klienta',
      value: 7,
      color: 'danger',
    },
    dataUsage: {
      label: 'Użycie danych',
      value: 8,
      color: 'blue',
    },
    dataRestore: {
      label: 'Przywrócenie danych',
      value: 9,
      color: 'darkblue',
    },
    staffActivation: {
      label: 'Aktywacja pracownika',
      value: 10,
      color: '#32c4cc',
    },
    staffDeactivation: {
      label: 'Dezaktywacja pracownika',
      value: 11,
      color: '#9f46a9',
    },
    renewSubscription: {
      label: 'Subskrypcja',
      value: 12,
      color: '#253386',
    },
  },
};
